export default __webpack_public_path__ + "static/avatar-mp-kayi-male-0-v4-detail-8e127b619c8b1750b538e3f4ee4d2036.png";